/** The longest message a quote request carries. */
export const QUOTE_MESSAGE_MAX = 2000

/** The most packages one quote request asks about. */
export const MAX_QUOTE_PACKAGES = 10
